import axios from "axios";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { organisationSignal } from "../../../signal/organisationSignal";
import { toast } from "react-toastify";
import { Button, Card, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { userSignal } from "../../../signal/userSignal";


export default function AccStatement(props) {

    const [accStatement, setAccStatement] = useState(null)
    const [companyName, setCompanyName] = useState(organisationSignal?.value?.tallyConfig?.companies?.length ? organisationSignal?.value?.tallyConfig?.companies[0]?.companyName : "")

    const getAccStatement = useQuery("getAccStatement", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/farmer/v2/getAccStatement?FarmerId=${props?.FarmerId}&companyName=${companyName}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        retry: false,
        onSuccess: (data) => {
            if (data.status) {
                setAccStatement(data?.data)
            } else {
                setAccStatement(null)
                toast.error(data.message);
            }
        },

        onError: (error) => {
            setAccStatement(null)
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    useEffect(() => {
        getAccStatement.refetch({ cancelRefetch: true })
    }, [companyName])

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Account Statement</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="d-flex justify-content-end">
                                    <div className="">
                                        <label htmlFor="Farmer">Select Company</label>
                                        <Select
                                            options={organisationSignal?.value?.tallyConfig?.companies.map((c) => {
                                                return { value: c?.companyName, label: c?.companyName }
                                            })}
                                            onChange={(e) => {
                                                if (e && e.value) {
                                                    setCompanyName(e.value);
                                                } else {
                                                    setCompanyName("");
                                                }
                                            }}

                                            value={{ value: companyName, label: companyName }}
                                        />
                                    </div>
                                </div>

                                <div className="mt-5 d-flex justify-content-center align-items-center">
                                    {(getAccStatement.isLoading || getAccStatement?.isFetching) ? <div className="d-flex justify-content-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                        :
                                        <>

                                            {

                                                accStatement ? <div>
                                                    <div className="position-relative border rounded-3 p-3 shadow">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h6 className="mb-0">{props?.FarmerName}.pdf</h6>
                                                            <a href="#" className="text-primary" onClick={(e) => {
                                                                e.preventDefault();
                                                                const newWindow = window.open("", "_blank");
                                                                const style = `
                                                                    <style>
                                                                        @media print {
                                                                            @page { 
                                                                                size: landscape; /* Sets landscape orientation */
                                                                                margin: 0; /* Removes headers/footers if supported */
                                                                            }
                                                                            body {
                                                                                -webkit-print-color-adjust: exact; /* Ensures background graphics are printed */
                                                                            }
                                                                        }
                                                                    </style>
                                                                `;

                                                                newWindow.document.write('<!DOCTYPE html><html><head>' + style + '</head><body>' + accStatement + '</body></html>');
                                                                newWindow.document.close();
                                                                newWindow.print();
                                                                newWindow.close();
                                                            }}>
                                                                <Button className="shadow" variant="outline-primary">
                                                                    <i className="fa fa-download"></i>
                                                                </Button>
                                                            </a>
                                                        </div>
                                                        <div className="mt-3" dangerouslySetInnerHTML={{ __html: accStatement }} />
                                                    </div>
                                                </div> : <span>Ops!, Statement not available</span>
                                            }
                                        </>
                                    }
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}
